import { atom } from 'jotai'

type SelectMasterFilteringItemType = {
  id: string
  selectedTexts?: string[]
}

export type RoomItemBasedFilteringItemType = {
  names?: string[]
  wingNames?: string[]
  floors?: string[]
  roomTypes?: string[]
  selectEnabledItems?: string[]
  memos?: string[]
  selectMasters?: SelectMasterFilteringItemType[]
  registerLimitAts?: string[]
  publishApplications?: string[]
  orderApplications?: string[]
  contractorNames?: string[]
  contractorConfirmed?: string[]
  selectEmailSentTimes?: string[]
  agreementRequestEmailSentTime?: string[]
  selectProxyRegisters?: string[]
  registrationStatuses?: string[]
}

export type RoomItemBasedFilteringKey = keyof RoomItemBasedFilteringItemType

type Input = {
  searchWord: string | undefined
  filteredRoomIds: string[] | undefined
  itemBasedFiltering: RoomItemBasedFilteringItemType | undefined
  rangeFilterRegisterLimitAt: { start?: Date; end?: Date } | undefined
}

const storeValues = atom<Input>({
  searchWord: undefined,
  filteredRoomIds: undefined,
  itemBasedFiltering: undefined,
  rangeFilterRegisterLimitAt: undefined,
})
export const roomTableFilteringStore = { state: storeValues } as const
